<div class="add-edit-master-data-block">
  @if (!isEdit) {
  <p>
    <span class="yellow-bg">
      *Disclaimer: Once a Forecast Cycle is added, the current data will be Archived, and new Forecast data will be
      updated for all Applications. Please ensure the updates are accurate.
    </span>
  </p>
  }
  <section class="ei-popup">
    <form class="ei-popup-form">
      <div class="row">
        <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
          <label>Forecast Cycle</label>
          @if (!isEdit) {
          <div class="form-field manual-options-width">
            <mat-form-field appearance="outline">
              <mat-select
                class="virtual-scroll"
                name="forecast_cycle"
                [(ngModel)]="Forecast_Cycle"
                (selectionChange)="dropdownChange($event, 'Forecast_Cycle')"
                placeholder="Select Forecast Cycle"
                panelClass="dropdown-options-width"
              >
                @for (option of forecastCycleArr; track option) {
                <mat-option [value]="option.Forecast_Cycle">
                  {{ option.Forecast_Cycle }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          } @if (isEdit) {
          <div>
            <p>{{ Forecast_Cycle }}</p>
          </div>
          }
        </div>
        <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
          <label>Select Year</label>
          @if (!isEdit) {
          <div class="form-field manual-options-width">
            <mat-form-field appearance="outline">
              <mat-select
                class="virtual-scroll"
                name="forecast_year"
                [(ngModel)]="Forecast_Year"
                (selectionChange)="dropdownChange($event, 'Forecast_Year')"
                placeholder="Select Forecast Year"
                panelClass="dropdown-options-width"
              >
                @for (option of forecastYearArr; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          } @if (isEdit) {
          <div>
            <p>{{ Forecast_Year }}</p>
          </div>
          }
        </div>
        <!-- <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 mb-3">
        <label>No of Weeks</label>
        <div *ngIf="!isPrevious" class="form-field manual-options-width">
          <mat-form-field appearance="outline">
            <mat-select class="virtual-scroll" name="weeks" [(ngModel)]="weeks"
              (selectionChange)="dateChange()" placeholder="Select No of Weeks"
              panelClass="dropdown-options-width">
              <mat-option *ngFor="let option of weeksArr" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="isPrevious">
          <p> {{ weeks }} </p>
        </div>
      </div> -->
        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
          <label>Forecast Start Year - Month</label>
          @if (!isPrevious) {
          <div class="form-field">
            <div class="flex-block">
              <mat-form-field appearance="outline">
                <mat-select
                  class="virtual-scroll"
                  name="start_year"
                  [(ngModel)]="Start_Year"
                  (selectionChange)="dropdownChange($event, 'Start_Year')"
                  placeholder="Select Year"
                  panelClass="dropdown-options-width"
                >
                  @for (option of endYearArr; track option) {
                  <mat-option [value]="option">
                    {{ option }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-select
                  class="virtual-scroll"
                  name="start_month"
                  [(ngModel)]="Start_Month"
                  (selectionChange)="dropdownChange($event, 'Start_Month')"
                  panelClass="dropdown-options-width"
                  placeholder="Select Month"
                >
                  @for (option of endMonthArr; track option) {
                  <mat-option [disabled]="option?.isDisabled" [value]="option.name">
                    {{ option.name }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          } @if (isPrevious) {
          <div>
            <p>{{ Start_Month }}, {{ Start_Year }}</p>
          </div>
          }
        </div>
        <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
          <label>Start Date</label>
          @if (!isPrevious) {
          <div class="form-field">
            <mat-form-field appearance="outline">
              <input
                name="start_date"
                matInput
                [matDatepicker]="picker"
                (dateChange)="dateChange()"
                value="Start_Date"
                [(ngModel)]="Start_Date"
                [min]="getFirstValidStartDate()"
                [matDatepickerFilter]="forceMondayFilter"
                [startAt]="getFirstValidStartDate()"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          } @if (isPrevious) {
          <div>
            <p>{{ Start_Date | date: 'mediumDate' }}</p>
          </div>
          }
        </div>
        <div class="col-md-2 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
          <label>End Date</label>
          @if (this.Weeks_Between_Start_End_Date) {
          <span class="weeks-info weeks-between">&nbsp;[{{ Weeks_Between_Start_End_Date }} week(s)]</span>
          } @if (!isPrevious) {
          <div class="form-field d-flex">
            <mat-form-field appearance="outline">
              <!-- <p [ngClass]="isPrevious?'':'mt-3 end_field_txt'">{{End_Date ? (End_Date | date: 'mediumDate') :
              'No Mapping'}}</p> -->
              <input
                name="end_date"
                matInput
                [matDatepicker]="picker"
                (dateChange)="dateChange()"
                value="Weeks_Between_Start_End_Date"
                [(ngModel)]="End_Date"
                [min]="getMinEndDate() || currentDate"
                [matDatepickerFilter]="forceFridayFilter"
                [startAt]="getFirstValidEndDate()"
              />
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          } @if (isPrevious) {
          <div>
            <p>{{ End_Date | date: 'mediumDate' }}</p>
          </div>
          }
        </div>
        <!-- <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
        <label>Email Start Date</label>
        <div *ngIf="!isPrevious" class="form-field">
          <mat-form-field appearance="outline">
            <input name="email_start_date" matInput [matDatepicker]="email_picker"
              (dateChange)="dateChange()" [(ngModel)]="Email_Start_Date" [min]="email_min_date"
              [max]="email_max_date" [matDatepickerFilter]="forceMondayFilter">
              <mat-datepicker-toggle matSuffix [for]="email_picker"></mat-datepicker-toggle>
              <mat-datepicker #email_picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div *ngIf="isPrevious">
            <p> {{ Email_Start_Date | date: 'mediumDate' }} </p>
          </div>
        </div> -->
        <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 mb-3">
          <label>Email Start Date</label>
          <div class="form-field">
            <p [ngClass]="isPrevious ? '' : 'mt-3 end_field_txt'">
              {{ formattedEmailStartDate }}
            </p>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
          <label>Admin End Date</label>
          @if (this.Weeks_Between_End_AdminEnd_Date || this.Weeks_Between_End_AdminEnd_Date===0) {
          <span class="weeks-info weeks-between">&nbsp;[{{ Weeks_Between_End_AdminEnd_Date }} week(s)]</span>
          } @if (!isPrevious) {
          <div class="form-field d-flex">
            <mat-form-field appearance="outline">
              <input
                name="admin_end_date"
                matInput
                [matDatepicker]="admin_end_date_picker"
                (dateChange)="adminEndDateChange()"
                [(ngModel)]="Admin_End_Date"
                [min]="admin_end_min_date"
                [matDatepickerFilter]="adminEndDateFilter"
              />
              <mat-datepicker-toggle matSuffix [for]="admin_end_date_picker"></mat-datepicker-toggle>
              <mat-datepicker #admin_end_date_picker></mat-datepicker>
            </mat-form-field>
          </div>
          } @if (isPrevious) {
          <div>
            <p>{{ Admin_End_Date | date: 'mediumDate' }}</p>
          </div>
          }
        </div>
        <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
          <label>Forecast End Year - Month</label>
          <div class="form-field">
            <p [ngClass]="isPrevious ? '' : 'end_field_txt'">
              {{ Start_Month && Start_Year ? Start_Year + 1 + ', Dec' : 'No Mapping' }}
            </p>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
          <label>FC Year</label>
          <div>
            <p>{{ Start_Year }}</p>
          </div>
        </div>
        <div class="col-md-2 col-sm-2 col-lg-2 col-xl-2 col-xs-2 mb-3">
          <label>Days for All Weeks</label>
          <div>
            <p>{{ daysForAllWeeks }}</p>
          </div>
        </div>
        <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xs-3 mb-3">
          <label>Days for Last Week</label>
          <div>
            <p>{{ daysForLastWeek }}</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
          <label>Current Year Description</label>
          <div class="form-field">
            <p class="m-0">
              <textarea
                (input)="fieldValueChange()"
                name="c_description"
                [(ngModel)]="C_Description"
                class="w-100 form-control comments-input"
                rows="4"
              ></textarea>
            </p>
            <p class="submit-button" style="color: darkgray;">Only {{ 300 - C_Description?.length }} Char Left</p>
          </div>
        </div>
        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
          <label>Future Year Description</label>
          <div class="form-field">
            <p class="m-0">
              <textarea
                (input)="fieldValueChange()"
                name="f_description"
                [(ngModel)]="F_Description"
                class="w-100 form-control comments-input"
                rows="4"
              ></textarea>
            </p>
            <p class="submit-button" style="color: darkgray;">Only {{ 300 - F_Description?.length }} Char Left</p>
          </div>
        </div>
        <!-- New field added for add Notification email -->
        @if (!isEdit) {
        <div class="col-md-4 col-sm-4 col-lg-4 col-xl-4 col-xs-4">
          <label>Notification Email</label>
          <div class="form-field">
            <input
              type="text"
              name="notification_email"
              [(ngModel)]="notification_email"
              class="w-100 form-control"
              placeholder="Enter comma separated emails"
            />
          </div>
        </div>
        }

        <!-- End of new field -->
      </div>
    </form>
  </section>
  <section class="submit-button">
    <button
      [disabled]="!isInValidData"
      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
      (click)="onCreate()"
    >
      Submit
    </button>
  </section>
</div>
